module.exports = __webpack_public_path__ + "Roboto-Bold.56a76a220d9c9765946d.ttf";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/roboto-fontface/fonts/roboto/Roboto-Bold.ttf
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-Bold.ttf
// module chunks = styles